import { Avatar } from "@mui/material";
import { DemoUserObject } from "assets/data/usersData";
import { Link } from "react-router-dom";
import { avatar } from "utils/assets_exports/images";
import { shortUserName } from "utils/helpers/shortUserName";
import { CustomComponentProps } from "utils/types/general.types";

export type UpdatedPostProps = CustomComponentProps & {
    user: DemoUserObject;
};

const JoinedUser = ({ user, className, style }: UpdatedPostProps) => {
    return (
        <Link
            to={`/users/view/${user.id}`}
            className={`flex justify-between w-full px-4 py-2 items-center gap-3 hover:shadow-lg hover:text-momeento-50 dark:text-white ${className}`}
            style={style}
        >
            <div className="flex justify-start items-center gap-2">
                <Avatar src={user.url || avatar} />
                <div>
                    <h3 className="font-medium text-sm">
                        {shortUserName(user.name, 20)}
                    </h3>
                    <p className="text-sm">{user.username}</p>
                </div>
            </div>
        </Link>
    );
};

export default JoinedUser;
